import { useMutation, useQuery } from '@tanstack/react-query';
import { api } from './client';
import { queryKeys } from './queries';

export function usePublicReport(linkId: string) {
  return useQuery({
    queryKey: queryKeys.publicReport(linkId),
    queryFn: ({ signal }) => api.getPublicReport(linkId, signal)
  });
}

// The export and card payloads are single-use: the server hands each out once, so a
// refetch would fail. Keep the first answer for the life of the page.
const singleUse = {
  retry: false,
  staleTime: Infinity,
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false
} as const;

export function useExportPayload(exportId: string) {
  return useQuery({
    queryKey: queryKeys.exportPayload(exportId),
    queryFn: ({ signal }) => api.exportPayload(exportId, signal),
    ...singleUse
  });
}

export function useCardPayload(exportId: string) {
  return useQuery({
    queryKey: queryKeys.cardPayload(exportId),
    queryFn: ({ signal }) => api.cardPayload(exportId, signal),
    ...singleUse
  });
}

export function useRemix() {
  return useMutation({
    mutationFn: (v: { linkId: string; targetWorkspaceId: string }) => api.remix(v.linkId, v.targetWorkspaceId)
  });
}

export function useAdminLogin() {
  return useMutation({ mutationFn: (password: string) => api.login(password) });
}

export function useExchange() {
  return useMutation({ mutationFn: (accessToken: string) => api.exchange(accessToken) });
}
